module.exports = __webpack_public_path__ + "static/media/jira_white_logo.889985f1.svg";